import { helper } from '@ember/component/helper';
import moment from 'moment-timezone';

const DEFAULT_FORMAT = 'D MMM YYYY HH:mm';

/**
 * Formatta un timestamp Unix in data leggibile
 */
function dateTicks([timestamp, format]) {
  if (!timestamp) return undefined;
  return moment.unix(timestamp).format(format || DEFAULT_FORMAT);
}
var dateTicks$1 = helper(dateTicks);

export { dateTicks, dateTicks$1 as default };
//# sourceMappingURL=date-ticks.js.map
